var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClockDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.0006 47.6673C37.9668 47.6673 47.6673 37.9668 47.6673 26.0006C47.6673 14.0345 37.9668 4.33398 26.0006 4.33398C14.0345 4.33398 4.33398 14.0345 4.33398 26.0006C4.33398 37.9668 14.0345 47.6673 26.0006 47.6673Z",
    stroke: "url(#paint0_linear_3569_10339)",
    strokeWidth: 4.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.501 34.6667L27.2706 29.4363C26.4579 28.6239 26.0012 27.5218 26.001 26.3727V13",
    stroke: "url(#paint1_linear_3569_10339)",
    strokeWidth: 4.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3569_10339",
    x1: 47.6673,
    y1: 26.0006,
    x2: 4.33398,
    y2: 26.0007,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#37384B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#37384B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3569_10339",
    x1: 32.501,
    y1: 23.8333,
    x2: 26.001,
    y2: 23.8333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#37384B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#37384B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockDark);
export default __webpack_public_path__ + "static/media/clock-dark.2107adc0632e1e7b98022bb1be1b7a1e.svg";
export { ForwardRef as ReactComponent };